import React from "react"
import { Embed } from "./KlaviyoFooterStyles"

export const KlaviyoFooter = ({layout}): JSX.Element => (
    <Embed layout={layout}>
        <div className="klaviyo-form-VbsMxu" />
    </Embed>
)
